import { useQuery } from '@tanstack/react-query';
import { getProjectflowStatus } from '../lib/api';
import { apiBase } from '../lib/runtime';

/**
 * A ProjectFlow-osszekotes allapota.
 *
 * Ebbol dol el minden: latszik-e a gomb (a cegnel be van-e kapcsolva), es ha
 * igen, kuldest vagy osszekotest ajanl. Egyetlen keres, hosszan gyorsitotarazva
 * - ez naponta legfeljebb egyszer valtozik.
 */
export function useProjectflowStatus() {
  return useQuery({
    queryKey: ['projectflow', 'status'],
    queryFn: getProjectflowStatus,
    staleTime: 5 * 60_000,
  });
}

/**
 * Az osszekotes inditasa - TELJES lapvaltassal.
 *
 * Nem `fetch`: a szerver egy atiranyitassal kuld tovabb a ProjectFlow
 * bejelentkezesehez, ahol a felhasznalonak a sajat bongeszojeben kell lennie.
 * Egy hatterbeli keres itt csak a valaszt kapna meg, a felhasznalot nem vinne
 * sehova.
 */
export function startProjectflowLink(): void {
  window.location.href = `${apiBase()}/api/projectflow/link`;
}
